import { render, staticRenderFns } from "./RentalVenueMain.vue?vue&type=template&id=737c653b&scoped=true&"
import script from "./RentalVenueMain.vue?vue&type=script&lang=js&"
export * from "./RentalVenueMain.vue?vue&type=script&lang=js&"
import style0 from "./RentalVenueMain.vue?vue&type=style&index=0&id=737c653b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c653b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('737c653b')) {
      api.createRecord('737c653b', component.options)
    } else {
      api.reload('737c653b', component.options)
    }
    module.hot.accept("./RentalVenueMain.vue?vue&type=template&id=737c653b&scoped=true&", function () {
      api.rerender('737c653b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/RentalVenue/RentalVenueMain.vue"
export default component.exports